<template>
	<div>
		<div>
			<v-card-title class="mt-4">
				<h2>Użytkownicy konkursu</h2>
			</v-card-title>
		</div>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Zmień rolę</span>
				</v-card-title>
				<v-card-text>
					<v-flex xs12 sm6 md4>
						<v-autocomplete name="rola" v-model="requestedRole" :items="contestRoles"
							label="rola"
							aria-label="contest role"
							for="contest-user-table-role"
							id="contest-user-table-role"
							data-vv-name="role"
							data-vv-as="role"
							:error-messages="vErrors.collect('department')"
							v-validate="'required'"></v-autocomplete>
					</v-flex>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="saveRole(requestedRole); dialog = false;">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<AddContestUserMenu :possibilities="possibilities" @save="saveUser"></AddContestUserMenu>
		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:loading="loading"
			:items="users">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.surname }}</td>
				<td>{{ props.item.email }}</td>
				<td>
					{{ contestRoleToString(props.item.role)}}
				</td>
				<td>
					<v-icon small class="mr-2"
						@click="dialog = true; editedItem = props.item" title="Edytuj">
						edit
					</v-icon>
					<v-icon small class="mr-2" color= "lightred"
						@click="deleteUser(props.item)" title="Usuń">
						delete
					</v-icon>
				</td>
			</template>
		</v-data-table>

	</div>
</template>

<script>
	import {PublicContest} from "../../../../api/generated/PublicContest";
	import AddContestUserMenu from "./AddContestUserMenu";

	export default {

		name: "ContestUserTable",
		components: {AddContestUserMenu},

		mounted () {
			this.removeEmptyTableLoading();
		},


		data () {

			return {
				dialog: false,
				loading: false,
				showDuplicateNameMessage: false,
				requestedRole: "",
				contestRoles: [
					"Brak",
					"Sekretarz konkursu",
					"Sekretarz konkursu (główny)",
					"Członek komisji",
					"Przewodniczący komisji",
					"Przewodniczący komisji (główny)"
				],
				tableHeaders: [
					{
						text: "Imię",
						sortable: false,
					},
					{
						text: "Nazwisko",
						sortable: false,
					},
					{
						text: "Email",
						sortable: false,
					},
					{
						text: "Rola w konkursie",
						sortable: false,
					},
					{
						text: "Akcja",
						value: "action",
						sortable: false,
					},
				],
				editedItem: {},

				editedIndex: -1,
			};
		},

		props: {
			users: Array,
			possibilities: Array
		},

		watch: {
			dialog (val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
				this.discardDuplicateNameError();
			},
		},

		computed: {
			isEdited () {
				return this.editedIndex !== -1;
			},
		},
		methods: {
			removeEmptyTableLoading () {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},

			contestRoleToString (role) {
				if (role === "LEADER") return "Przewodniczący komisji";
				if (role === "MAIN_LEADER") return "Przewodniczący komisji (główny)";
				if (role === "SECRETARY") return "Sekretarz konkursu";
				if (role === "MAIN_SECRETARY") return "Sekretarz konkursu (główny)";
				if (role === "COMMITTEE_USER") return "Członek komisji";
				if (role === "NONE") return "-";
				return "nierozpoznana rola";
			},
			discardDuplicateNameError () {
				this.showDuplicateNameMessage = false;
			},

			deleteUser (item) {
				this.$confirm("Czy na pewno chcesz usunąć tego użytkownika? Jeżeli aktualnie jest członkiem jakiejś komisji nie będzie to możliwe.", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie użytkownika konkursu",
					width: 500
				})
					.then(result => {
						if (result) {
							PublicContest.deleteUser(this, item.userId, successResponse => {
									this.$emit("refresh");
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć użytkownika. Sprawdź, czy nie jest członkiem jakiejś komisji.", errorResponse);
								});
						}
					});
			},

			saveRole (role) {
				PublicContest.postChangeUserContestRole(this, this.editedItem.userId, role, successResponse => {
						this.$emit("refresh");
            this.$messagesBus.$emit("success", "Rola użytkownika została pomyślnie zmieniona", successResponse);
					}, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się zmienić roli użytkownika. Sprawdź, czy nie jest członkiem jakiejś komisji / nie ma przypisanych ocen.", errorResponse);
        });
			},

			saveUser (userId) {
				PublicContest.putUser(this, this.$route.params.id, userId, () => {
					this.$emit("refresh");
				});
			}

		},

	};
</script>

<style scoped>

</style>
